export default "__VITE_ASSET__TtwAsW$5__"